package music.jammers.client.shared.component

import androidx.compose.foundation.text.ClickableText
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.withStyle

private const val URL_REGEX_PATTERN = """(http[s]?://[^\s]+)"""
private const val URL_ANNOTATION_TAG = "URL"
private const val INITIAL_START_INDEX = 0

@Composable
fun AppAutoLinkClickableText(
    text: String,
    modifier: Modifier = Modifier,
    textStyle: TextStyle = LocalTextStyle.current.copy(color = MaterialTheme.colorScheme.onBackground),
    linkStyle: SpanStyle = SpanStyle(color = MaterialTheme.colorScheme.tertiary),
    onClick: (String) -> Unit,
) {
    val annotatedString = buildAnnotatedString {
        var currentStartIndex = INITIAL_START_INDEX
        val urlRegex = URL_REGEX_PATTERN.toRegex()
        val urlMatches = urlRegex.findAll(text)

        for (match in urlMatches) {
            val link = match.value
            append(text.substring(currentStartIndex, match.range.first))

            pushStringAnnotation(tag = URL_ANNOTATION_TAG, annotation = link)

            withStyle(style = linkStyle) {
                append(link)
            }
            pop()

            currentStartIndex = match.range.last + 1
        }

        append(text.substring(currentStartIndex))
    }

    ClickableText(
        style = textStyle,
        modifier = modifier,
        text = annotatedString,
        onClick = { offset ->
            annotatedString.getStringAnnotations(URL_ANNOTATION_TAG, offset, offset)
                .firstOrNull()?.let { annotation ->
                    onClick(annotation.item)
                }
        }
    )
}